/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ListingsInputs */

const en_listings = /** @type {(inputs: ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listings`)
};

const id_listings = /** @type {(inputs: ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing`)
};

/** @type {(inputs: ListingsInputs) => LocalizedString} */
const es_listings = en_listings;

/** @type {(inputs: ListingsInputs) => LocalizedString} */
const fr_listings = en_listings;

/** @type {(inputs: ListingsInputs) => LocalizedString} */
const de_listings = en_listings;

/** @type {(inputs: ListingsInputs) => LocalizedString} */
const ja_listings = en_listings;

/** @type {(inputs: ListingsInputs) => LocalizedString} */
const zh_listings = en_listings;

/** @type {(inputs: ListingsInputs) => LocalizedString} */
const ar_listings = en_listings;

/** @type {(inputs: ListingsInputs) => LocalizedString} */
const it_listings = en_listings;

/** @type {(inputs: ListingsInputs) => LocalizedString} */
const ru_listings = en_listings;

/** @type {(inputs: ListingsInputs) => LocalizedString} */
const pt_listings = en_listings;

/** @type {(inputs: ListingsInputs) => LocalizedString} */
const ko_listings = en_listings;

/**
* | output |
* | --- |
* | "Listings" |
*
* @param {ListingsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listings = /** @type {((inputs?: ListingsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ListingsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listings(inputs)
	if (locale === "es") return es_listings(inputs)
	if (locale === "fr") return fr_listings(inputs)
	if (locale === "de") return de_listings(inputs)
	if (locale === "ja") return ja_listings(inputs)
	if (locale === "zh") return zh_listings(inputs)
	if (locale === "ar") return ar_listings(inputs)
	if (locale === "id") return id_listings(inputs)
	if (locale === "it") return it_listings(inputs)
	if (locale === "ru") return ru_listings(inputs)
	if (locale === "pt") return pt_listings(inputs)
	return ko_listings(inputs)
});